<div class="dialog-header">
	<div class="header-title"><span style="font-size: 120%;">Send E-Mail</span></div>

	<div style="flex: 1"></div>


	<div class="buttons-block">
		<button class="header-button send-button" mat-button (click)="sendEmail()">
			<span *ngIf="sendLoading">
				<lib-mini-progress-spinner></lib-mini-progress-spinner>
			</span>
			<span *ngIf="!sendLoading">Send</span>
		</button>
	</div>

	<button mat-button class="close-button-container" mat-dialog-close disableRipple="true">
		<mat-icon>clear</mat-icon>
	</button>
</div>

<div class="edit-block">
	<!-- <app-send-email [mailData]="data"></app-send-email> -->
	<div class="static-label">
		This is static message, and can't be edited. To Edit please send through QBO.
	</div>

	<textarea class="email-text-area" matInput type="text" [(ngModel)]="emailBody" name="message" disabled></textarea>
</div>